import { fleekActions } from '../actionTypes';
import { ModalPayloadType } from '../interfaces/Posts';

interface ActionType {
  type: any;
  payload: any;
}

const initialState: ModalPayloadType = {
  loader: false,
  error: {},
  isActive: false,
  postId: 0,
  type: '',
  postData: {}
};

export const modalReducer = (state = initialState, action: ActionType) => {
  // console.log('action reducer', action);
  switch (action.type) {
    case fleekActions.TOGGLE_MODAL:
      const updatedState = { ...state, ...action.payload };
      return updatedState;

    case fleekActions.FETCH_INDIVIDUAL_POST_DATA_REQUEST:
      return { ...state, loader: true, error: {} };

    case fleekActions.FETCH_INDIVIDUAL_POST_DATA_SUCCESS:
      return { ...state, loader: false, postData: action.payload };

    case fleekActions.FETCH_INDIVIDUAL_POST_DATA_FAILURE:
      return {
        ...state,
        loader: false,
        error: action.payload
      };

    case fleekActions.RESET_INDIVIDUAL_POST_DATA:
      return initialState;

    default:
      return state;
  }
};
